
import { useMemo } from 'react';
import { getAmount, getBudgetAmount } from "../utilities/financeUtils";

const useProcessedData = (balanceData, budgetData, lastYearBalanceData) => {
  const processedData = useMemo(() => {
    const omsætningIaltEntireLastYearAmount = getAmount(lastYearBalanceData, 1995);
    const omsætningIaltAmount = getAmount(balanceData, 1995);
    const omsætningBudgetAmount = getBudgetAmount(budgetData, 1995);
    const produktionsomkostningerAmount = getAmount(balanceData, 1198001);
    const administrationsomkostningerAmount = getAmount(balanceData, 1198002);
    const periodensResultatAmount = getAmount(balanceData, 5998);
    const produktionsomkostningerBudgetAmount = getBudgetAmount(budgetData, 1198001);
    const administrationsomkostningerBudgetAmount = getBudgetAmount(budgetData, 1198002);
    const periodensResultatBudgetAmount = getBudgetAmount(budgetData, 5998);

    return {
        omsætningIaltEntireLastYearAmount,
        omsætningIaltAmount,
        omsætningBudgetAmount,
        produktionsomkostningerAmount,
        administrationsomkostningerAmount,
        periodensResultatAmount,
        produktionsomkostningerBudgetAmount,
        administrationsomkostningerBudgetAmount,
        periodensResultatBudgetAmount,
    };
  }, [balanceData, budgetData, lastYearBalanceData]);

  return processedData;
};

export default useProcessedData;
